import { render } from "./InvestigationTypes.vue?vue&type=template&id=a2cc7dee"
import script from "./InvestigationTypes.vue?vue&type=script&lang=js"
export * from "./InvestigationTypes.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__